export const environment = {
  production: true,
  envName: 'prod',
  apiUrl: 'https://www.ultraf1fl.in/core/api/v1/f1-fantasy-league-api',
  // razor pay related code
  razorPay_key: 'rzp_live_zmptlEJ1sOwlus'  // Murali Razorpay Live  Key
};
